import { ThemeConfig } from "antd";
import { createContext } from "react";

export interface HostThemeConfig {
  appName: string;
  faviconUrl: string;

  /** @deprecated */ logoUrlColored?: string;
  /** @deprecated */ logoUrlWhite?: string;

  logoUrl?: string;
  logoSimpleUrl?: string;
  logoAppBarUrl?: string;

  theme: {
    light: NonNullable<ThemeConfig["token"]>;
    dark?: ThemeConfig["token"];
  };
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const HostThemeConfigContext = createContext<HostThemeConfig | null>(undefined!);
